'use client';

import React from 'react';
import { ExperienceType } from '../types';
import KeyDetails from '@/components/packages/KeyDetails';
import { NeedToKnow } from '@/types/activityDetailsTypes';

interface ExperienceKeyDetailsProps {
  experience: unknown;
  type: ExperienceType;
}

export const ExperienceKeyDetails: React.FC<ExperienceKeyDetailsProps> = ({
  experience,
}) => {
  if (!experience) return null;

  const exp = experience as {
    needToKnow?: NeedToKnow[];
    guidelines?: { needToKnow?: NeedToKnow[] };
  };

  const needToKnow = exp?.needToKnow || exp?.guidelines?.needToKnow || [];

  if (!Array.isArray(needToKnow) || needToKnow.length === 0) {
    return null;
  }

  return <KeyDetails details={needToKnow} />;
};
